export var RPCMethod;
(function (RPCMethod) {
    // MethodSubmitTx submits a new transaction to the Darknode for acceptance
    // into the transaction pool.
    RPCMethod["SubmitTx"] = "ren_submitTx";
    // MethodQueryTx returns the latest information about a transaction
    // identified by a transaction hash.
    RPCMethod["QueryTx"] = "ren_queryTx";
    // MethodQueryTxs returns pages of transactions with optional filtering by
    // status and tags.
    RPCMethod["QueryTxs"] = "ren_queryTxs";
    // MethodQueryBlock returns a block identified by the block height.
    RPCMethod["QueryBlock"] = "ren_queryBlock";
    // MethodQueryBlocks returns recently committed blocks.
    RPCMethod["QueryBlocks"] = "ren_queryBlocks";
    // MethodQueryConfig returns the node configuration.
    RPCMethod["QueryConfig"] = "ren_queryConfig";
    // MethodQueryState returns the contract state.
    RPCMethod["QueryState"] = "ren_queryState";
})(RPCMethod || (RPCMethod = {}));
// The following lines will throw a type error if RenVMResponses or RenVMParams
// aren't defined for all RPC methods.
// type _responsesCheck = RenVMResponses[RPCMethod];
// type _paramsCheck = RenVMParams[RPCMethod];
() => { };
() => { };
//# sourceMappingURL=methods.js.map